/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bigPriceContainer[_ngcontent-%COMP%]{font-size:30px;color:var(--ion-color-primary)}.bigPriceContainer[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{margin-right:7px}.flexStart[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;position:relative;align-items:center}.flexEnd[_ngcontent-%COMP%]{display:flex;text-align:right;justify-content:flex-end}.labels-info[_ngcontent-%COMP%]{margin-left:10px;font-size:14px;letter-spacing:1px;margin-top:15px}"];
export { styles as styles };
